module.exports = __webpack_public_path__ + "static/taste-2428bc96398ba01341e24477568f4e2e.jpg";